import {MakeDialog} from "../../../components/Shared/MakeDialog";
import React, {Component, Fragment} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {formsCheckboxUpdater, formsUpdater, getFormFieldValue} from "../../Applications/shared/shared";
import "../views/entry.css";

export class AARQuestionnaireDialog extends Component {
  constructor(props) {
    super(props);
    let formData = props.data || {};
    let defaultLocation = props.defaults.location || "";
    if (props.defaults.apptType === 5 || props.defaults.apptType === 13) {
      defaultLocation = "Office";
    }
    if (!formData['dateSeen']) {
      formData['dateSeen'] = props.defaults.start_date;
    }
    if (!formData['apptLocation']) {
      formData['apptLocation'] = defaultLocation;
    }
    this.state = {
      disabled: props.disabled || false,
      formData: formData,
    }
  }

  render() {
    return (
      <MakeDialog isOpen={true}
                  className={"AARQuestionnaireDialog"}
                  footer={<div>
                    <Button color={"primary"}
                            onClick={() => this.props.onSave && this.props.onSave(this.state.formData)}
                    >Save</Button>
                    <Button onClick={() => this.props.onClose && this.props.onClose()}>Close</Button>
                  </div>}
                  header="AAR Questionnaire">
        <Row>
          <Col xs={12} lg={6}>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">FSP Breakout</Label>
                  <div style={{display: "flex", height: 25}}>
                    $<Input
                    type="text"
                    id="fspBreakout1"
                    value={getFormFieldValue(this.state.formData['fspBreakout1'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                    &nbsp;/&nbsp;$<Input
                    type="text"
                    id="fspBreakout2"
                    value={getFormFieldValue(this.state.formData['fspBreakout2'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">1st Draft/Effective Date</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="date"
                      id="fspEffectiveDate"
                      value={getFormFieldValue(this.state.formData['fspEffectiveDate'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Col>

          <Col xs={12} lg={6}>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">MBA Coverage: Member / Spouse</Label>
                  <div style={{display: "flex", height: 25}}>
                    $<Input
                    type="text"
                    id="mbaMember"
                    value={getFormFieldValue(this.state.formData['mbaMember'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                    &nbsp;/&nbsp;$<Input
                    type="text"
                    id="mbaSpouse"
                    value={getFormFieldValue(this.state.formData['mbaSpouse'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">TSP Amount: Traditional / Roth</Label>
                  <div style={{display: "flex", height: 25}}>
                    $<Input
                    type="text"
                    id="tspTraditional"
                    value={getFormFieldValue(this.state.formData['tspTraditional'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                    &nbsp;/&nbsp;$<Input
                    type="text"
                    id="tspRoth"
                    value={getFormFieldValue(this.state.formData['tspRoth'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <div style={{display: "flex", height: 25}}>
                    <Label for="subject" check={false}>Changes</Label>
                    ?&nbsp;&nbsp;
                    <Input type={"checkbox"} id={"tspChanged"}
                           style={{marginLeft: "unset", marginTop: "unset", position: "unset"}}
                           onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this, () => {
                             if (!this.state.formData['tspChanged']) this.setState({
                               formData: {
                                 ...this.state.formData,
                                 tspEffectiveDate: undefined
                               }
                             });
                           })}
                           defaultChecked={getFormFieldValue(this.state.formData['tspChanged'])}/>
                    {this.state.formData['tspChanged'] && (
                      <Fragment>
                        &nbsp;&nbsp;Effective&nbsp;Date:&nbsp;<Input
                        type="date"
                        id="tspEffectiveDate"
                        value={getFormFieldValue(this.state.formData['tspEffectiveDate'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                      </Fragment>
                    )}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Col>

          <Col xs={12} lg={6}>
            <Row>
              <Col xs="12">
                Appointment Details
                <FormGroup>
                  <Label for="subject">Date Seen</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="date"
                      id="dateSeen"
                      value={getFormFieldValue(this.state.formData['dateSeen'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">Amount committed to before above changes occur</Label>
                  <div style={{display: "flex", height: 25}}>
                    $<Input
                    type="text"
                    id="amtCommitted"
                    value={getFormFieldValue(this.state.formData['amtCommitted'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">How did we get their name?</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="text"
                      id="referralInfo"
                      value={getFormFieldValue(this.state.formData['referralInfo'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">Where was the appt?</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="text"
                      id="apptLocation"
                      value={getFormFieldValue(this.state.formData['apptLocation'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Col>

          <Col xs={12} lg={6}>
            <Row>
              <Col xs="12">
                Member Details
                <FormGroup>
                  <Label for="subject">Time in Service</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="text"
                      id="timeInService"
                      value={getFormFieldValue(this.state.formData['timeInService'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">Work At</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="text"
                      id="serviceLocation"
                      value={getFormFieldValue(this.state.formData['serviceLocation'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">Job Description</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="text"
                      id="serviceDescription"
                      value={getFormFieldValue(this.state.formData['serviceDescription'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">Planning on staying in</Label>
                  <div style={{display: "flex", height: 25}}>
                    <Input
                      type="text"
                      id="servicePlans"
                      value={getFormFieldValue(this.state.formData['servicePlans'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="subject">Previously Saved</Label>
                  <div style={{display: "flex", height: 25}}>
                    $<Input
                    type="text"
                    id="previouslySaved"
                    value={getFormFieldValue(this.state.formData['previouslySaved'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Col>

          <Col xs="12">
            <FormGroup>
              <Label for="subject">Notes</Label>
              <div style={{display: "flex"}}>
                <Input
                  type="textarea"
                  rows={3}
                  id="notes"
                  value={getFormFieldValue(this.state.formData['notes'])}
                  onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                />
              </div>
            </FormGroup>
          </Col>

        </Row>
      </MakeDialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/modals/AARQuestionnaireDialog.js